import { MediaViewer as AtlaskitMediaViewer } from '@atlaskit/media-viewer';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import React, { useEffect, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const EXTERNAL_MEDIA_ITEM_TYPE = 'external-image';

/**
 * Wrapper over "@atlaskit/media-viewer" which:-
 * - requires only marketplace external images
 * - disables body scroll when media viewer is open
 * - provides a wrapper over the media viewer with a testId
 */
export const MediaViewer = props => {
  const {
    mediaItems,
    selectedMediaItem,
    onClose,
    testId
  } = props;
  const mediaViewerRef = useRef(null);
  useEffect(() => {
    const mediaViewerElement = mediaViewerRef.current;
    if (mediaViewerElement) disableBodyScroll(mediaViewerElement);
    return () => {
      if (mediaViewerElement) enableBodyScroll(mediaViewerElement);
    };
  }, []);

  // returns full set of media
  const toMediaItem = media => ({
    mediaItemType: EXTERNAL_MEDIA_ITEM_TYPE,
    dataURI: media.dataURI,
    name: media.name
  });
  return /*#__PURE__*/_jsx("div", {
    ref: mediaViewerRef,
    "data-testid": testId,
    children: /*#__PURE__*/_jsx(AtlaskitMediaViewer, {
      selectedItem: toMediaItem(selectedMediaItem),
      items: mediaItems.map(toMediaItem),
      onClose: onClose
    })
  });
};